import { Component, OnInit, AfterViewChecked, ElementRef, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { Employer } from '../../models/employer';
import { RenewalEmploymentInfo } from '../../models/renewal-employment-info';
import { AdditionalIncome } from '../../models/additionalincome';
import { Industry } from '../../models/industry';
import { EmploymentStatus } from '../../models/employmentstatus';
import { RenewalPrimaryEmployerService } from '../../../services/renewal-primary-employercog.service';
import { ApplicationDataService } from '../../../services/application.service';
import { Router, ActivatedRoute } from '@angular/router';
import { FormControl, NgForm } from '@angular/forms';
import { TelephoneNumber } from 'app/models/telephone-number';
import { LabelValue } from 'app/models/labelvalue';

// import { AutoCompleteComponent } from '../../../geoautocomplete/auto-complete.component'

@Component({
  selector: 'app-roommate-confirm-employer-cog',
  templateUrl: './roommate-confirm-employer-cog.component.html',
  styleUrls: ['./roommate-confirm-employer-cog.component.css'],
})
export class RoommateConfirmEmployerComponent implements OnInit {
  @ViewChild('employmentInfo', { static: true }) private myScrollContainer: ElementRef;
  RentalApplicantKey: number;
  model: RenewalEmploymentInfo;
  RentalApplicationKey: number;
  employments: Employer[] = [];
  employmentStatus: LabelValue[];
  additionalIncome: AdditionalIncome = new AdditionalIncome();
  errorMessage: string;
  industries: LabelValue[];
  displayValidationMsg = false;
  autoCompleteSettings: any = {
    showSearchButton: false,
    showRecentSearch: false,
    geoTypes: ['establishment'],
    geoCountryRestriction: ['us'],
    inputPlaceholderText: 'Employer Name'
  };
  AddAdditionalApplicantKey: number = null;
  AddAdditionalApplicantName: string = null;
  CompletedByOther: boolean = false;
  phoneNumber: TelephoneNumber = new TelephoneNumber('', '', '');
  empPhoneNumber: TelephoneNumber = new TelephoneNumber('', '', '');

  @ViewChild('employmentForm', { static: true })
  employmentForm: NgForm;

  constructor(
    private employmentService: RenewalPrimaryEmployerService,
    private applicationService: ApplicationDataService,
    public router: Router, public route: ActivatedRoute
  ) {
    this.industries = [];

    this.model = new RenewalEmploymentInfo();

    const RenewalKey = localStorage.getItem('RenewalKey');

    if (RenewalKey !== undefined && RenewalKey !== null) {

      this.model.LeaseRenewalKey = Number(localStorage.getItem('RenewalKey'));

      this.employmentService.getEmploymentInformation(this.model)
        .subscribe(res => this.onGetEmploymentSuccess(res), res => this.employmentService.handleError(res));

      this.applicationService.getEmploymentStatuses().subscribe(res => this.getEmploymentStatus(res),
        res => this.applicationService.handleError(res))

    }
  }

  ngOnInit() {
    this.applicationService.getRentalIndustries()
      .subscribe(res => this.onGetIndustriesSuccess(res), err => this.applicationService.handleError(err));
  }

  onDateBlur(event) {
    this.employmentForm.controls[event.target.id].updateValueAndValidity({ emitEvent: false });
  }

  ngAfterViewChecked() {
    // this.scrollToBottom();
  }

  phoneChanged() {
    console.log(`phone number: ${this.phoneNumber?.format()}`)
  }

  supervisorPhoneChanged() {
    console.log(`phone number: ${this.phoneNumber?.format()}`)
  }

  scrollToBottom(): void {
    try {
      this.myScrollContainer.nativeElement.scrollIntoView(false);
    } catch (err) { console.log('error: ' + err); }
  }

  getEmploymentStatus(statuses: EmploymentStatus[]) {
    this.employmentStatus = [];
    for (const status of statuses) {
      this.employmentStatus.push({ label: status.Title, value: status.EmploymentStatusKey });
    }
  }

  cancelEdit() {
    localStorage.removeItem('AddAdditionalApplicantKey');
    localStorage.removeItem('AddAdditionalApplicantName');
    this.router.navigate(['/application/applicants']);
  }

  onSubmit() {
    this.model.Employments = [];
    this.employments.forEach(val => this.model.Employments.push(Object.assign({}, val)));

    if (this.model.Employments.length > 0) {
      for (const emp of this.model.Employments) {
        emp.IsCurrnet = false;
        emp.Phone = emp.PhoneNumber.format();
        emp.SupervisorPhone = emp.SupervisorPhoneNumber.format();
      }
      this.model.Employments[this.model.Employments.length - 1].IsCurrnet = true;
    }

    this.employmentService.updateEmploymentInformation(this.model)
      .subscribe(res => this.onUpdateSuccess(res), res => this.employmentService.handleError(res));
  }

  onCloseWarning() {
    this.displayValidationMsg = false;
    this.onAddEmployerClick();
  }

  onUpdateSuccess(employments: RenewalEmploymentInfo) {
    this.router.navigate(['/renewalcog/renewal-dashboard']);
  }

  async onGetEmploymentSuccess(income: RenewalEmploymentInfo) {
    this.model = income;
    let AddAdditionalApplicantKey = localStorage.getItem('AddAdditionalApplicantKey');

    if (AddAdditionalApplicantKey !== null && AddAdditionalApplicantKey !== undefined) {
      this.CompletedByOther = true;
    }
    else {
      this.CompletedByOther = false;
    }

    if ((income.Employments !== null || income.Employments !== undefined) && income.Employments.length !== 0) {


      if (income.Employments[0].Phone) {
        const phoneTemp = income.Employments[0].Phone.replace(/[^A-Z0-9]/ig, "");
        income.Employments[0].PhoneNumber = new TelephoneNumber(phoneTemp.substr(0, 3), phoneTemp.substr(3, 3), phoneTemp.substr(6, 4));
      }

      if (income.Employments[0].SupervisorPhone) {
        const supPhoneTemp = income.Employments[0].SupervisorPhone.replace(/[^A-Z0-9]/ig, "");
        income.Employments[0].SupervisorPhoneNumber = new TelephoneNumber(supPhoneTemp.substr(0, 3), supPhoneTemp.substr(3, 3), supPhoneTemp.substr(6, 4));
      }

      income.Employments[0].StartDate = new Date(income.Employments[0].StartDate);

      if (income.Employments[0].EndDate != null) {
        income.Employments[0].EndDate = new Date(income.Employments[0].EndDate);
      }

      this.employments = income.Employments;

    } else {
      this.employments = [];

      this.employments.push(new Employer());
    }
  }

  onGetIndustriesSuccess(industries: Industry[]) {
    this.industries = [];
    for (const industry of industries) {
      this.industries.push({ label: industry.Title, value: industry.RentalIndustryKey });
    }
  }

  onAddEmployerClick() {
    if (!this.employments) {
      this.employments = [];
    }
    this.employments.push(new Employer());
  }

  onRemoveEmployerClick(employment: Employer) {
    const index = this.employments.indexOf(employment);
    this.employments.splice(index, 1);

    let i = 0;

    // let autoCompleteComps:AutoCompleteComponent[] = this.autoCompleteInputs.toArray();

    // for(const emp of this.employments){
    //   autoCompleteComps[i].locationInput = emp.EmployerName;
    //   i = i + 1;
    // }

  }

  autoCompleteCallback1(selectedData: any, data: any) {
    if (selectedData.name !== undefined) {
      this.employments[data].EmployerName = selectedData.name;
      this.employments[data].Phone = selectedData.formatted_phone_number;
      this.employments[data].Address = selectedData.formatted_address;
    }
    else {
      this.employments[data].EmployerName = selectedData;
    }
  }

  initAutoCompleteSettings(data: any, initialValue: any) {
    this.autoCompleteSettings.name = data;
    this.autoCompleteSettings.id = data;
    this.autoCompleteSettings.inputString = initialValue;
    return this.autoCompleteSettings;
  }

  // Do Not Delete.  ngFor will break on add remove without.
  listTrack(o) {
    return o;
  }
}
